import { SVG } from '../SVG'

export const Reports = ({ inactive = false, style = {}, ...props }) => {
  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
      <path
        d='M15.0938 20.125H5.03125C4.84063 20.125 4.65781 20.0493 4.52302 19.9145C4.38823 19.7797 4.3125 19.5969 4.3125 19.4062V6.46875C4.3125 6.27813 4.38823 6.09531 4.52302 5.96052C4.65781 5.82573 4.84063 5.75 5.03125 5.75H12.2188L15.8125 9.34375V19.4062C15.8125 19.5969 15.7368 19.7797 15.602 19.9145C15.4672 20.0493 15.2844 20.125 15.0938 20.125Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.1875 5.75V3.59375C7.1875 3.40313 7.26323 3.22031 7.39802 3.08552C7.53281 2.95073 7.71563 2.875 7.90625 2.875H15.0938L18.6875 6.46875V16.5312C18.6875 16.7219 18.6118 16.9047 18.477 17.0395C18.3422 17.1743 18.1594 17.25 17.9688 17.25H15.8125'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.90625 13.6562H12.2188'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.90625 16.5312H12.2188'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SVG>
  )
}
